/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const UserName = styled.span`
  font-size: ${theme.fontSizes.md};
  color: ${theme.color.text.text01};
  font-weight: ${theme.fontWeights.medium};
  line-height: 1.5em;
`;

export const UserImage = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 2.5rem;
  border: 3px solid ${theme.color.border.border01};
`;
